import { Box, Heading, Image, Paragraph, TextButton } from '@zillow/constellation-10';

import zillowAndPlaidSvg from '@assets/zillow-plaid.svg';
import PaymentMethodModule from '@renter-hub/components/PaymentMethodModule';

export const ReconnectBankAccount = ({
  accountName,
  accountLast4,
  onDeletePaymentMethodClick,
}: {
  accountName: string;
  accountLast4: string;
  onDeletePaymentMethodClick?: () => void;
}) => (
  <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.md)' }}>
    <Image alt="zillow-plaid" css={{ width: '100px' }} src={zillowAndPlaidSvg as unknown as string} />
    <Heading level={2} textStyle="heading-xs">
      Reconnect your account to make a payment
    </Heading>
    <Paragraph>
      A verified connection to your account lets us process your payments faster and reduces the risk of failed
      payments. We use our trusted partner, Plaid, to connect your account.
    </Paragraph>
    <PaymentMethodModule accountName={accountName} accountLast4={accountLast4} />
    <TextButton css={{ alignSelf: 'flex-start' }} onClick={onDeletePaymentMethodClick}>
      Delete
    </TextButton>
  </Box>
);
